// @flow
import React, { Children, forwardRef, type Node } from 'react';
import classnames from 'classnames';

import { NAVIGATIONLARGE_SUBNAV_MAX_HEIGHT } from 'Components/widgets/navigation/Navigation.constants';

type Props = {
  children?: Node,
  isActive?: boolean,
};

export const NavigationLargePanel = forwardRef<Props, *>((props: Props, ref) => {
  const { children, isActive } = props;

  if (!Children.count(children)) {
    return null;
  }

  return (
    <div className="absolute inset-x-0 pointer-events-none top-full z-0">
      <div
        className={classnames('my-0 mx-auto max-w-site overflow-hidden w-full transition-none', {
          'absolute opacity-0 pointer-events-none rtl:left-outOfBounds': !isActive,
          'opacity-100 pointer-events-auto': isActive,
        })}
        data-testid="NavigationLarge-subItems"
        ref={ref}
        style={{
          maxHeight: NAVIGATIONLARGE_SUBNAV_MAX_HEIGHT,
          ...(isActive ? { transition: 'opacity ease-in 0.4s 0.2s' } : null),
        }}
      >
        {children}
      </div>
    </div>
  );
});
